<template>
  <div
    class="owal env ui container"
  >
    <owal-panel
      title="Environment"
      class="owal env ui panel"
    >
      <env-row
        v-for="key in Object.keys(env)"
        :key="key"
        class="owal env ui row"
        :title="key"
        :subtitle="env[key]"
      />
    </owal-panel>
  </div>
</template>

<script>
import OwalPanel from '@/libraries/owal-ui/panels/OwalPanel'
import EnvRow from './EnvRow'
export default {
  name: 'EnvUi',
  components: {
    OwalPanel,
    EnvRow,
  },
  computed: {
    env () {
      return process.env
    },
  },
}
</script>

<style scoped>
.owal.env.ui.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

.owal.env.ui.panel {
  /* max-width: 68.5714285714rem; */
  margin: 1rem;
  max-height: 90%;
  max-width: 90vw;
  width: stretch;
  overflow: auto;
}

.owal.panel.active.window >>> .owal.panel.container {
  display: block;
}

</style>
